import {DossierInterventionActiviteAssechementModel} from './dossierInterventionActiviteAssechement.model';

export class ActiviteAssechement {
    id: number;
    technicien_id: number;
    visit_date: string;
    humidity: string;
    dossier_intervention_id: number;
    dossier_intervention_activite_assechement: DossierInterventionActiviteAssechementModel;

    public constructor(init?: Partial<ActiviteAssechement>) {
      Object.assign(this, init);
    }
  }
